import { QuestionCollectionResponse } from '../models/audit-collection-response';
import { Answer, InsertAnswers, SelectedResponse } from '../models/insert-answer';

export function mapQuestionCollectionToInsertAnswers(questionCollectionResponse: QuestionCollectionResponse): InsertAnswers {
	const answers: Answer[] = questionCollectionResponse.questions.map((question) => {
		const selectedResponses: SelectedResponse[] = question.responseCheckItems.map((item) => ({
			responseId: item.responseId,
			checked: item.checked,
		}));

		return {
			scheduledAuditId: question.scheduledAuditId,
			selectedResponseId: question.selectedResponseId,
			responseText: question.responseText,
			questionId: question.questionId,
			comments: question.comments || '',
			fileExternalIds: [],
			responseType: question.responseType,
			selectedResponses,
		};
	});

	return {
		scheduledAuditId: questionCollectionResponse.scheduledAuditId,
		answers,
	};
}
